import styled from 'styled-components'
import { Form } from 'formik'
import Icon from '@mdi/react'

import { WhiteBlock } from 'components/Layout'
import { Font14 } from 'components/Typography'
import theme from 'theme_'
import CommonLinkButton from 'components/Button/CommonLinkButton'
import CommonButton from 'components/Button/CommonButton'

export const HostPasswordResetContainer = styled(WhiteBlock)`
  width: 100%;
  padding-bottom: ${theme.spacing.lg};
`

export const HostPasswordResetHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  min-height: 26px;
  margin-bottom: 24px;
`

export const HostPasswordResetTitle = styled.div`
  color: ${theme.colors.moreGrey};
  ${Font14};
`

export const HostPasswordResetEditButton = styled(CommonLinkButton)``

export const HostPasswordResetStyledIcon = styled(Icon)`
  height: 20px;
  width: 20px;
  color: ${theme.colors.horizonOrange};

  :hover {
    cursor: pointer;
    opacity: 0.8;
  }
`

export const HostPasswordResetForm = styled(Form)`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
`

export const HostPasswordResetFormContent = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  max-width: 320px;
`
export const HostPasswordResetFormPasswordRow = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  max-width: 420px;
`
export const HostPasswordResetFormPassword = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  max-width: 320px;
`
export const HostPasswordResetFormPasswordTip = styled.div`
display: flex;
justify-content: flex-end;
float: right;
`

export const HostPasswordResetFormControl = styled.div`
  display: flex;
  justify-content: flex-end;
  width: 100%;
  gap: 10px;
  animation: ${theme.animations.fadeIn} 0.2s ease-out;
`

export const HostPasswordResetCancelButton = styled(CommonButton)`
  background: transparent;
`

export const HostPasswordResetSubmitButton = styled(CommonButton)``

export const HostPasswordResetButtonsWrapper = styled.div`
  display: flex;
  gap: 10px;
  align-items: center;
  justify-content: center;
  min-width: 240px;
  min-height: 42px;
`
